let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ko5Dp")).then(() => parcelRequire('hFFoW'));